var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49997 1H6.49997V2H9.49997V1ZM8.49997 5.5H7.49997V10H8.49997V5.5ZM13.29 3.79506L14 4.50006L12.755 5.74506C13.4637 6.96028 13.677 8.40184 13.3505 9.77022C13.024 11.1386 12.1829 12.3286 11.0019 13.0929C9.82083 13.8573 8.39072 14.1372 7.00867 13.8746C5.62661 13.612 4.39887 12.827 3.58053 11.6827C2.7622 10.5384 2.41619 9.12284 2.6144 7.73008C2.81261 6.33733 3.53979 5.07448 4.64487 4.20393C5.74994 3.33337 7.14793 2.92205 8.54839 3.05541C9.94884 3.18877 11.2441 3.85657 12.165 4.92006L13.29 3.79506ZM5.4999 12.2417C6.23992 12.7361 7.10995 13.0001 7.99997 13.0001C9.19344 13.0001 10.338 12.526 11.1819 11.682C12.0259 10.8381 12.5 9.69353 12.5 8.50006C12.5 7.61004 12.236 6.74001 11.7416 5.99999C11.2471 5.25997 10.5443 4.68319 9.72205 4.3426C8.89978 4.002 7.99498 3.91289 7.12206 4.08652C6.24915 4.26016 5.44733 4.68874 4.81799 5.31808C4.18865 5.94741 3.76007 6.74924 3.58644 7.62215C3.4128 8.49506 3.50192 9.39987 3.84251 10.2221C4.18311 11.0444 4.75988 11.7472 5.4999 12.2417Z",
    fill: "#363C43"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer16);
export default __webpack_public_path__ + "static/media/Timer16.ba1954420dd0d923a57bbb381c13c7f4.svg";
export { ForwardRef as ReactComponent };